import React, { Component } from 'react';
import './DatiCliente.css';

import { Formik, Form, Field } from 'formik';
import clienti from '../../services/Api/Utenti/UtentiApi.js';
import DialogConfirm from '../../MessageBox/DialogConfirm';
// import Dialog from 'react-bootstrap-dialog';
// import Modal from '../../MessageBox/Modal';
// import DialogTest from '../../MessageBox/DialogTest';
// import DialogDemo from '../../MessageBox/DialogDemo';
import './DatiUte.css';
export class DatiUteComponent extends Component {
  constructor(props) {
    super(props);
    console.log('props : ', props);
    console.log('this.state : ', this.props.clie);
  }

  state = {
    nome: '',
    cognome: '',
    email: '',
    telefono: '',
    password: '',
    obj: {
      title: 'Operazione Registra Dati Utente ',
      msg: 'sicuro di abbandonare',
      msg1: "l'inserimento dei dati",
      annulla: 'Annulla',
    },
    isShowing: false,
  };
  /**
   *
   * @param {
   *
   * } props
   */
  openModalHandler = () => {
    this.setState({
      isShowing: true,
    });
  };

  closeModalHandler = () => {
    this.setState({
      isShowing: false,
    });
  };

  ///////////////
  componentDidMount(props) {
    console.log('componentDidMount padre :', this.props);
    //console.log('ciccio :', JSON.parse(this.props.match.params.id));
    this.setState({
      // id: this.props.match.params.id,
      nome: 'claudio',
    });
  }
  Elimina = (z) => {
    console.log('Elimina ;', z);
  };

  Annulla = (e) => {
    console.log('Cliente annullato ', this.props.msgBox);

    // props.msgBox('222');

    // if (window.confirm('Abbandoni il caricamento?')) {
    //   this.props.history.push(`/utente`);
    // }
  };

  salva = (value) => {
    console.log(value);

    clienti.insUtente({
      nome: value.nome,
      cognome: value.cognome,
      email: value.email,
      telefono: value.telefono,
      password: value.password,
    });
  };

  handleResponse = (response) => {
    console.log(response);
  };
  handleError = (error) => {
    console.log('OUTPUT: clientiComponent -> handleError -> error', error);
  };

  CancelAction = (x) => {
    console.log('CancelAction ', x);
  };
  OKAction = () => {
    console.log('Cancel was clicked!');
    this.props.history.push(`/utente`);
  };
  render() {
    let { nome, cognome, email, telefono, password } = this.state;
    return (
      <section className='container py-5'>
        <div className='card'>
          <div className='card-body'>
            <h3 className='card-title mb-4'>Dati dell' Utente</h3>
            {/* <Test Elimina={this.Elimina} /> */}
            {/* {this.state.isShowing ? (
              <div onClick={this.closeModalHandler} className='back-drop'></div>
            ) : null}

            {/* <button className='open-modal-btn' onClick={this.openModalHandler}>
              Open Modalxx
            </button> */}
            {/* <button
              type='button'
              onClick={this.openModalHandler}
              //onClick={this.props.msgBox}
              className='btn btn-warning insute'
            >
              Open Modalxx
            </button>
            {this.state.isShowing && (
              <Modal
                className='modal'
                show={this.state.isShowing}
                close={this.closeModalHandler}
              ></Modal>
            )}{' '} */}

            {/* <DialogTest />
            <DialogDemo /> */}
            <Formik
              initialValues={{
                nome,
                cognome,
                email,
                telefono,
                password,
              }}
              onSubmit={this.salva}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className='form-group'>
                    <img
                      src={`../user.png`}
                      className='img-sm rounded-circle border'
                      alt='imgute'
                    />
                  </div>
                  <div className='form-row'>
                    <div className='col form-group'>
                      <label>Nome *</label>
                      <Field type='text' name='nome' className='form-control' />
                    </div>

                    <div className='col form-group'>
                      <label>Cognome *</label>
                      <Field
                        type='text'
                        name='cognome'
                        className='form-control'
                      />
                    </div>
                  </div>

                  <div className='form-row'>
                    <div className='col form-group'>
                      <label>Telefono</label>
                      <Field
                        type='text'
                        name='telefono'
                        className='form-control'
                      />
                    </div>
                    <div className='col form-group'>
                      <label>Email</label>
                      <Field
                        type='text'
                        name='email'
                        className='form-control'
                      />
                    </div>
                  </div>
                  <div className='form-row'>
                    <div className='col form-group'>
                      <label>Password</label>
                      <Field
                        type='password'
                        name='password'
                        className='form-control'
                      />
                    </div>
                  </div>
                  <div>
                    <button type='submit' className='btn btn-primary insute'>
                      Salva
                    </button>
                    <DialogConfirm
                      className='DialogConfirm'
                      ref={(DialogConfirm) => {
                        this.dialog = DialogConfirm;
                      }}
                      OKAction={this.OKAction}
                      CancelAction={this.CancelAction}
                      obj={this.state.obj}
                    />

                    {/* <button
                      type='button'
                      onClick={this.Annulla}
                      className='btn btn-warning insute'
                    >
                      Annulla
                    </button> */}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </section>
    );
  }
}

export default DatiUteComponent;

// const {Component} = React;

// const DATA = {
//   "1880": { pirates: 20000, temperature: 14.5, className: "app--one" },
//   "1920": { pirates: 15000, temperature: 15.0, className: "app--two" },
//   "1940": { pirates: 5000, temperature: 15.3, className: "app--three" },
//   "1980": { pirates: 400, temperature: 15.7, className: "app--four" },
//   "2000": { pirates: 17, temperature: 16, className: "app--five" },
// }

// class App extends Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       selectedYear: null
//     }
//   }

//   handleClick(year, e) {
//     e.preventDefault()

//     // this.setState() permette di modificare uno o piu dati dello state
//     // A ogni modifica, il metodo 'render' viene chiamato automaticamente
//     // e vengono aggiornate o modificate le parti della return che
//     // differiscono dalla return precedente.

//     this.setState({ selectedYear: year })
//   }

//   renderYearbuttons(year) {

//     // 'classNames' è un'utility che ho inserito tramite cdn per poter scrivere con facilità
//     // il codice che serve per cambiare il css di un div quando avviene un determinato cambiamento
//     // nello State.

//     let appYearsItem = classNames(
//       "app__years__item",
//       { "app__years__item--active": year === this.state.selectedYear }
//     )

//     // Viene aggiunto un attributo di React, 'onClick'. Il metodo che contiene verrà chiamato
//     // ogni volta che l'utente cliccherà sul div.

//     return (
//       <div
//         key={year}
//         className={ appYearsItem }
//         onClick={ this.handleClick.bind(this, year) }
//         >
//         { year }
//       </div>
//       )
//   }

//   render() {
//     let app = classNames(
//       "app",
//       this.state.selectedYear ? DATA[this.state.selectedYear].className : ""
//     )

//     return (
//       <div className={ app }>
//         <div className="app__years">
//           { Object.keys(DATA).map(this.renderYearbuttons.bind(this)) }
//         </div>
//       </div>
//     );
//   }
// };

// ReactDOM.render(
//   <App />,
//   document.getElementById('app'))
